import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tooltip } from 'antd';
import styles from './styles.less';
import { LocalizationContext } from '../../../hoc/Localization';

const Perk = ({ perks }) => {
  const { locale } = useContext(LocalizationContext);
  return (
    <Row>
      {perks.map(perk => (
        <Col key={perk.id} span={12} order="flex" xs={12}>
          <div className={styles.perk}>
            <div className={styles.text}>
              <h3 className={styles.title}>{perk[`title_${locale}`]}</h3>
              <Tooltip placement="topLeft" title={perk.description}>
                <p>{perk[`description_${locale}`]}</p>
              </Tooltip>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

Perk.propTypes = {
  perks: PropTypes.array,
};

Perk.defaultProps = {
  perks: [],
};

export default Perk;
